<p></p> <!-- a little hacky white space :) -->
<div class="row">
    <div class="allConversationsColumn">
        <h2>Conversation</h2>
        <div *ngIf="conversations && completedConversations">
            <div *ngFor="let convo of conversations">
                <button (click)="handleConversationSelection(convo)"
                    [ngClass]="selectedConversation && selectedConversation.Name === convo.Name ? 'selectedConversationButton' : 'unselectedConversationButton'"
                    [disabled]="!convo.IsCompletedByStudent">
                    {{convo.Name}}
                </button>
                <div *ngIf="selectedConversation && selectedConversation.Name === convo.Name">
                    <button *ngFor="let artifact of convo.CreatedArtifacts.slice().reverse()"
                        [ngClass]="selectedArtifactMetadata && selectedArtifactMetadata.StartedActivityID === artifact.StartedActivityID ? 'selectedActivityButton' : 'unselectedActivityButton'"
                        (click)="handleConversationInstanceSelection(artifact)">{{DateReturner(artifact)}}</button>
                </div>
            </div>
        </div>
        <app-loading-spinner *ngIf="!conversations || !completedConversations"></app-loading-spinner>
    </div>
    <div class="currentConversationColumn"
        *ngIf="!isLoadingInitialData && (!completedConversations || completedConversations.length == 0)">
        <div class="currentConversationColumnHeader">
            <p style="color:gray; font-style: italic; padding-top: 60px;">This student has not completed any
                conversations yet.</p>
        </div>
    </div>
    <div class="currentConversationColumn" *ngIf="selectedConversation">
        <h2 class="currentConversationColumnHeader" style="font-size:x-large">{{selectedConversation.Description}}</h2>
        <div class="currentConversationContent" *ngIf="!isLoadingArtifact && selectedConversationArtifact">
            <app-daisychain-response *ngFor="let bundledresponse of bundledResponses" [data]="bundledresponse"
                [studentID]="studentID" (onVideoLoadStarted)="playWasCalled($event)"
                (onVideoLoaded)="handlePlayResponseVideo($event)">
            </app-daisychain-response>
        </div>
        <div *ngIf="!isLoadingArtifact && !selectedConversationArtifact">
            <p> No data for this conversation yet</p>
        </div>
        <app-loading-spinner class="loadingSpinner" *ngIf="isLoadingArtifact"></app-loading-spinner>
    </div>
</div>